const state = {
  data: null,
  isActive: false,
  showSubscriptionOverlay: false,
};

const mutations = {
  handleGetInfoMovie(state, payload) {
    state.data = payload;
  },
  handleShowInfoMovie(state, payload) {
    state.isActive = payload;
  },
  handleSetShowSubscriptionOverlay(state, payload) {
    state.showSubscriptionOverlay = payload;
  },
};

export default {
  state,
  mutations,
};
